<template>
  <b-card>
    <b-tabs @activate-tab="changeTabs($event)" content-class="mt-3">
      <b-tab title="گزارش ریالی" active>
        <list-table
          :url="url"
          title="تعداد تراکنش های ریالی و کارمزد هایش"
          :fields="fields"
          :params="params"
          :excelroute="true"
        ></list-table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import TableShowData from "../../components/table";
export default {
  name: "CalcIncome",
  data() {
    return {
      url: "~transaction/transaction/admin/wageReport",
      fields: [
        { key: "website_name", label: "نام وبسایت" },
        { key: "count", label: "تعداد تراکنش ها", sortable: true },
        {
          key: "amount",
          label: "مجموع کارمزد تراکنش ها",
          formatter(value, key, item) {
            return Number((value && value > 0) ? parseInt(value) : 0).toLocaleString();
          },
          sortable: true,
        },
        {
          key: "shaparak_amount",
          label: "مجموع کارمزد نظام بانکی تراکنش ها",
          formatter(value, key, item) {
            return Number((value) ? parseInt(value) : 0).toLocaleString();
          },
          sortable: true,
        },
        {
          key: "SumCost",
          label: "مجموع مبلغ تراکنش ها",
          formatter(value, key, item) {
            return Number(parseInt(value)).toLocaleString();
          },
          sortable: true,
        },
      ],
      params: [
        { field: "datefrom", type: "date-picker", label: "از تاریخ" },
        { field: "dateto", type: "date-picker", label: "تا تاریخ" },
        {
          field: "mdid12_money_type",
          type: "select",
          label: "واحد پولی",
          value: 483,
          options: [
            { value: 483, text: "ریالی" },
            { value: 1722, text: "دلاری" },
          ],
        },
      ],
      enableStripe: false,
      enablePerfectmoney: false,
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {
    changeTabs(e) {
      this.enablePerfectmoney;
      e == 1 ? (this.enableStripe = true) : (this.enablePerfectmoney = true);
    },
  },
};
</script>